<template>
  <div id="home">
    <topSlider :exhibit_data='exhibit_data'></topSlider>
    <CircleNav></CircleNav>
    <giftEvent></giftEvent>
    <freeTicket></freeTicket>
    <recommend></recommend>
    <schedule :exhibit_data2='exhibit_data2'></schedule>
    <middleSlider></middleSlider>
    <news></news>
    <indexIntro></indexIntro>
    <brilliant></brilliant>
    <btnBallon></btnBallon>
  </div>
</template>

<script>
import TopSlider from '@/components/index/TopSlider'
import CircleNav from '@/components/index/CircleNav'
import GiftEvent from '@/components/index/GiftEvent'
import FreeTicket from '@/components/index/FreeTicket'
import Recommend from '@/components/index/Recommend'
import Schedule from '@/components/index/Schedule'
import MiddleSlider from '@/components/index/MiddleSlider'
import News from '@/components/index/News'
import IndexIntro from '@/components/index/IndexIntro'
import Brilliant from '@/components/index/Brilliant'
import BtnBallon from '@/components/index/BtnBallon'
import 'swiper/dist/css/swiper.min.css'

export default {
  name: 'home',
  metaInfo: {
    title: 'TopLink 上聯國際展覽有限公司', // set a title
    meta: [{                 // set meta
      name: 'description',
      content: '上聯國際展覽是國內展覽規模第一大的專業展覽公司。主要服務項目為承辦國內外各類型展覽，及展覽徵展業務、議題創意、媒體公關、展覽顧問、整合行銷規劃、國際策展交流等。世貿展,展覽資訊,展覽活動,近期展覽,展覽檔期,展覽公司,展覽好康,抽獎,免費門票'
    }]
  },
  components: {
    'topSlider': TopSlider,
    'CircleNav': CircleNav,
    'giftEvent': GiftEvent,
    'freeTicket': FreeTicket,
    'recommend': Recommend,
    'schedule': Schedule,
    'middleSlider': MiddleSlider,
    'news': News,
    'indexIntro': IndexIntro,
    'brilliant': Brilliant,
    'btnBallon': BtnBallon,
  },
  data() {
    return {
      exhibit_data: [],
      exhibit_data2: [],
    }
  },
  computed: {
  },
  created() {
    this.fetchExhibit()
  },
  methods: {
    fetchExhibit() {
      var app = this
      var exhibit_data_api = process.env.VUE_APP_API + 'tlweb/new_exhibit?sort=start_date%20asc'
      var date = new Date()
      var params = {/*online: '1', */recent: '1', rows: '100', 'end_date': `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` };
      app.axios
        .get(exhibit_data_api, { params: params })
        .then((res) => {
          // app.exhibit_data = res.data.data.data
          app.exhibit_data = Object.assign([], res.data.data.data);
          app.exhibit_data2 = Object.assign([], res.data.data.data);
          // console.log(app.exhibit_data) 
        })
        .catch((err) => {
          console.log('錯誤:' + err)
        })
    },

  }
}
</script>
